import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 常用语（controller/agent：/v1/agent/{agentId}/quick-replies/**）
 */

/* ===== 分组 ===== */
export function listQuickReplyGroups(agentId) {
  return axios.get(`${base.url}/service/v1/agent/${agentId}/quick-replies/groups`)
}
export function createQuickReplyGroup(agentId, body) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/quick-replies/groups`,
    JSON.stringify(body), { headers: { 'Content-Type': 'application/json' } })
}
export function updateQuickReplyGroup(agentId, groupId, body) {
  return axios.put(`${base.url}/service/v1/agent/${agentId}/quick-replies/groups/${groupId}`,
    JSON.stringify(body), { headers: { 'Content-Type': 'application/json' } })
}
export function deleteQuickReplyGroup(agentId, groupId) {
  return axios.delete(`${base.url}/service/v1/agent/${agentId}/quick-replies/groups/${groupId}`)
}

/* ===== 条目 ===== */
export function listQuickReplyTree(agentId) {
  return axios.get(`${base.url}/service/v1/agent/${agentId}/quick-replies`)
}
export function searchQuickReplies(agentId, keyword) {
  return axios.get(`${base.url}/service/v1/agent/${agentId}/quick-replies/search`, { params: { keyword } })
}
export function createQuickReply(agentId, body) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/quick-replies`,
    JSON.stringify(body), { headers: { 'Content-Type': 'application/json' } })
}
export function updateQuickReply(agentId, id, body) {
  return axios.put(`${base.url}/service/v1/agent/${agentId}/quick-replies/${id}`,
    JSON.stringify(body), { headers: { 'Content-Type': 'application/json' } })
}
export function deleteQuickReply(agentId, id) {
  return axios.delete(`${base.url}/service/v1/agent/${agentId}/quick-replies/${id}`)
}

/* ===== 批量 ===== */
export function downloadQuickReplyTemplate(agentId) {
  return axios.get(`${base.url}/service/v1/agent/${agentId}/quick-replies/template`, { responseType: 'blob' })
}
export function importQuickReplies(agentId, file) {
  const fd = new FormData()
  fd.append('file', file)
  return axios.post(`${base.url}/service/v1/agent/${agentId}/quick-replies/import`, fd,
    { headers: { 'Content-Type': 'multipart/form-data' } })
}
export function batchDeleteQuickReplies(agentId, ids) {
  return axios.delete(`${base.url}/service/v1/agent/${agentId}/quick-replies/batch`,
    { headers: { 'Content-Type': 'application/json' }, data: JSON.stringify({ ids }) })
}
export function exportQuickReplies(agentId) {
  return axios.get(`${base.url}/service/v1/agent/${agentId}/quick-replies/export`, { responseType: 'blob' })
}
export function previewImportQuickReplies(agentId, file) {
  const fd = new FormData()
  fd.append('file', file)
  return axios.post(`${base.url}/service/v1/agent/${agentId}/quick-replies/import/preview`, fd,
    { headers: { 'Content-Type': 'multipart/form-data' } })
}
export function executeImportQuickReplies(agentId, items) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/quick-replies/import/execute`,
    JSON.stringify({ items }), { headers: { 'Content-Type': 'application/json' } })
}